export default __webpack_public_path__ + "static/media/restLogo.e87b1dd6.png";